
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"130","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 2c7.02.743 14.038 1.602 21.106 1.816 12.305.374 24.61-.421 36.912-.576 19.848-.249 39.813-.445 59.637.554 3.424.172 10.345.775 10.345.775","stroke":"#FF2948","stroke-width":"4","stroke-linejoin":"bevel"}})])
          )
        }
      }
    